import Rx from 'rxjs/Rx';

class FormService {
  constructor() {
    this.isSubmitting = new Rx.BehaviorSubject(false);
  }

  /**
   * This function would evaluate forms in the current page resulting to
   * an object in par with the current state of the form
   * 
   * It is required that all field have name attribute in
   * order to  be evaluated.
   */
  evaluateForms() {
    let evaluation = {};

    let forms = document.getElementsByTagName('form');
   
    for (let form of forms) {
      let formName = form.getAttribute('name');
      let formEvaluation = {};

      let formElements = form.elements;

      for (let idx = 0; idx < formElements.length; idx++) {
        let element = formElements[idx];
        let elementEvaluation = {};
        let elementName = element.getAttribute('name');
        if (elementName) {
          if (element.tagName === 'SELECT') {
            elementEvaluation['text'] = element.options[element.selectedIndex].text;
            elementEvaluation['value'] = element.options[element.selectedIndex].value;
          }

          if (element.tagName === 'INPUT') {
            elementEvaluation['text'] = element.value;
            elementEvaluation['value'] = element.value;
          }
        }
 
        formEvaluation[elementName] = elementEvaluation;
      } 

      evaluation[formName] = formEvaluation;
    }

    return evaluation;
  }
}

export default FormService;



// WEBPACK FOOTER //
// ./client/app/shared/ui/form.service.js